import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '../../../finance/expenses/travelrefund/mixins/ExpenseMixin.js'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh.js'
import CountryRepository from '@/shared/http/repositories/geo/country.js'
import CityRepository from '@/shared/http/repositories/geo/city'
import StateRepository from '@/shared/http/repositories/geo/state'
import ActionsForm from '@/shared/mixins/actionsForm'
import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason.js'
import formData from './form-modal'
import { loading } from '@/shared/utils/UIHelper.js'

export default {
  name: 'InfoModalTravel',
  mixins: [ExpenseMixin, ActionsForm],
  components: {AutocompleteZ},
  data () {
    return {
      codigoResponsavel: false,
      nomeResponsavel: false,
      nomeFavorecido: false,
      demissao: false,
      codigoFavorecido: false,
      BuscaCodigo: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      BuscaNome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      FavorecidoCodigo: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      FavorecidoNome: {
        value: null,
        options: [],
        required: false,
        state: null,
        code: null
      },
      step: 0,
      person: [],
      disabledSenAdiantamento: false,
      dataRegional: [],
      statusStep: [
        {
          icone: 'fas fa-info',
          name: 'Informações',
          value: 0
        },
        {
          icone: 'fas fa-info',
          name: 'Informações',
          value: 1
        }
      ],
      pais: null,
      form: formData(),
      semAdiantamento: false,
      dataTravel: [],
      dataCountry: [],
      dataState: [],
      dataStateFim: [],
      dataCity: [],
      dataCityFim: [],
      dataNow: null
    }
  },
  mounted () {
    this.getAllRegional()
    this.getAllTravel()
    this.getCountry()
    this.$emit('onLoad')
    this.GetDatePickerNow()
  },
  watch: {
    'form.motivoViagemId.value' (newvalue) {
      this.verificaMotivo(newvalue)
    },
    'BuscaCodigo.value': function (value) {
      if (value != null) {
        this.codigoResponsavel = true
        this.form.responsavelId.value = this.BuscaCodigo.value
      } else {
        this.codigoResponsavel = false
      }
    },
    'BuscaNome.value': function (value) {
      if (value != null) {
        this.nomeResponsavel = true
        this.form.responsavelId.value = this.BuscaNome.value
      } else {
        this.nomeResponsavel = false
      }
    },
    'FavorecidoCodigo.value': function (value) {
      if (value != null) {
        this.codigoFavorecido = true
        this.form.funcionarioId.value = this.FavorecidoCodigo.value
      } else {
        this.codigoFavorecido = false
      }
    },
    'FavorecidoNome.value': function (value) {
      if (value != null) {
        this.nomeFavorecido = true
        this.form.funcionarioId.value = this.FavorecidoNome.value
      } else {
        this.nomeFavorecido = false
      }
    }
  },
  methods: {
    verificaMotivo (value) {
      if (value) {
        TravelReasonRepository.motivoViagemVenda(value)
          .then(Response => {
            this.disabledSenAdiantamento = Response.data
            if (this.disabledSenAdiantamento === true) {
              this.form.semAdiantamento.value = false
            }
          })
          .catch(Error => console.log(Error))
      }
    },
    GetDatePickerNow () {
      this.dataNow = new Date()
      if (this.form.dataInicio.value === null) {
        this.form.dataInicio.value = this.dataNow
      }
      if (this.form.dataFim.value === null) {
        this.form.dataFim.value = this.dataNow
      }
    },
    changeByName () {

    },
    show () {
      this.$refs['add-travel-modal'].show()
    },
    close () {
      this.$refs['add-travel-modal'].hide()
    },
    nextStep () {
      this.step++
    },
    clone (obj) {
      loading.push()
      this.onChangeCountryEnd(obj.cidadeOrigem.estado.paisID)
      this.onChangeStateEnd(obj.cidadeOrigem.estadoID)
      this.onChangeCountryFim(obj.cidadeDestino.estado.paisID)
      this.onChangeStateFim(obj.cidadeDestino.estadoID)
      this.form.cidadeOrigemId.value = obj.cidadeOrigemID
      this.form.estadoOrigemID.value = obj.cidadeOrigem.estadoID
      this.form.paisOrigemID.value = obj.cidadeOrigem.estado.paisID
      this.form.cidadeDestinoId.value = obj.cidadeDestinoID
      this.form.estadoDestinoID.value = obj.cidadeDestino.estadoID
      this.form.paisDestinoID.value = obj.cidadeDestino.estado.paisID
      this.form.dataInicio.value = obj.dataViagemInicio
      this.form.dataFim.value = obj.dataViagemFim
      this.form.regionalId.value = obj.secaoRHID
      this.form.passagem.value = obj.possuiPassagemArea
      this.$refs.favorecidoTypeahead.setValue(obj.favorecido)
      this.$refs.obraRHTypeahead.setValue(obj.obra, 'referencia')
      this.$refs.responsavelTypeahead.setValue(obj.responsavel)
      this.form.motivoViagemId.value = obj.motivoViagemID
      loading.pop()
    },
    onChangeCodeSection () {

    },
    rollback (obj) {
      this.form = obj
      this.onChangeCountryEnd(this.form.paisOrigemID.value)
      this.onChangeStateEnd(this.form.estadoOrigemID.value)
      this.onChangeCountryFim(this.form.paisDestinoID.value)
      this.onChangeStateFim(this.form.estadoDestinoID.value)
      this.$refs.favorecidoTypeahead.setValue(obj.favorecido)
      this.$refs.obraRHTypeahead.setValue(obj.obra)
      this.$refs.responsavelTypeahead.setValue(obj.responsavel)
    },
    onClearSection (e) {
      let input = this.dataRegional.find((Element) => Element.codigo === parseInt(e))
      if (input !== null) {
        this.form.regionalId.value = input.id
      } else {
        this.form.regionalId.value = null
      }
    },
    onSelectDate () {
    },
    getCountry () {
      CountryRepository.GetAll()
        .then(Response => {
          this.dataCountry = Response.data.data
          if (this.dataCountry.length <= 1) {
            this.pais = this.dataCountry[0].id
            this.form.paisOrigemPreSelecionaoID.value = this.dataCountry[0].id
            this.form.paisDestinoPreSelecionadoID.value = this.dataCountry[0].id
            this.getEstate()
            this.getEstateFim()
          }
        })
        .catch(Error => console.log(Error))
    },
    onChangeStateFim (e) {
      this.getCityFim(e)
    },
    getCityFim (id) {
      loading.push()
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCityFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    onChangeCountryEnd (e) {
      this.getEstate(e)
    },
    onChangeCountryFim (e) {
      this.getEstateFim(e)
    },
    getEstateFim (id) {
      loading.push()
      if (id == null) {
        id = this.pais
      }
      StateRepository.GetAllByCountryID(id)
        .then(Response => {
          this.dataStateFim = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    backInfo () {
      this.form = JSON.parse(window.localStorage.getItem('formFirst'))
      if (this.dataCountry.length <= 1) {
        this.form.paisOrigemID.value = this.pais
        this.form.paisDestinoID.value = this.pais
        this.form.motivoViagemId.value = this.form.motivoViagemId.value
        this.verificaMotivo(this.form.motivoViagemId.value)
        this.onChangeCountryEnd(this.form.paisOrigemID.value)
        this.onChangeCountryFim(this.form.paisDestinoID.value)
      }
      this.form.motivoViagemId.value = this.form.motivoViagemId.value
      this.verificaMotivo(this.form.motivoViagemId.value)
      this.onChangeCountryEnd(this.form.paisOrigemID.value)
      this.onChangeStateEnd(this.form.estadoOrigemID.value)
      this.onChangeCountryFim(this.form.paisDestinoID.value)
      this.onChangeStateFim(this.form.estadoDestinoID.value)
      this.onSearchFavorecidoById(this.form.funcionarioId.value)
      this.onSearchObraId(this.form.obraId.value)
      this.onSearchResponsavelById(this.form.responsavelId.value)
    },
    onChangeStateEnd (e) {
      this.GetCity(e)
    },
    GetCity (id) {
      loading.push()
      if (id == null) {
        id = this.pais
      }
      CityRepository.GetAllByStateID(id)
        .then(Response => {
          this.dataCity = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getEstate (id) {
      if (id == null) {
        id = this.pais
      }
      loading.push()
      StateRepository.GetAllByCountryID(id)
        .then(Response => {
          loading.pop()
          this.dataState = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    getAllRegional () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then(Response => {
          loading.pop()
          this.dataRegional = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    onSetPosition (e) {
      this.person = e
      if (e.demissao != null) {
        this.demissao = true
        this.dataTravel = []
        this.form.motivoViagemId.value = null
        this.getAllTravel(1)
      } else {
        this.getAllTravel()
      }
      this.form.funcionariofuncao.value = e.cargo.nome
    },
    GetEstadoAndFuncao () {
    },
    getAllTravel (value) {
      if (value === 1) {
        let venda = false
        loading.push()
        TravelReasonRepository.GetAllByDesligado(venda)
          .then(Response => {
            this.dataTravel = Response.data.data
            loading.pop()
          })
          .catch(Error => loading.pop())
      } else {
        loading.push()
        TravelReasonRepository.GetAll()
          .then(Response => {
            this.dataTravel = Response.data.data
            loading.pop()
          })
          .catch(Error => loading.pop())
      }
    },
    handleCheckboxInput () {
      this.semAdiantamento = this.form.semAdiantamento.value
      this.$emit('semAdiantamento', this.semAdiantamento)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/InfoModalTravel/InfoModalTravel.js